import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

// Maps each role to its home route
const ROLE_HOME = {
  super_admin: "/superadmin",
  admin:       "/admin",
  supervisor:  "/supervisor",
  operator:    "/operator",
};

function PrivateRoute({ children, allowedRoles }) {
  const { currentUser, userRole } = useAuth();

  // Not logged in → go to login
  if (!currentUser) {
    return <Navigate to="/login" replace />;
  }

  // Logged in but wrong role → redirect to their correct dashboard
  if (allowedRoles && !allowedRoles.includes(userRole)) {
    const home = ROLE_HOME[userRole] || "/login";
    return <Navigate to={home} replace />;
  }

  return children;
}

export default PrivateRoute;